import { Component, OnInit } from '@angular/core';
import { ForgotPasswordService } from '@app/services/authentication/forgotPassword.service';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse, resetPassword } from '@app/models/OTPResult';
import { Router } from '@angular/router';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forgetpassword.component.html'
})
export class ForgetPasswordComponent implements OnInit {

    otpResult = new ApiResponse();
    reset: resetPassword = new resetPassword();
    errorMessageMobileNumber: string = '';
    errorMessageNumericMobileNumber: string = '';
    errorMessageOTP: string = '';
    errorMessageNumericOTP: string = '';
    hideMobileNumber:boolean = true;
    ngOnInit() {
        this.otpResult.Status = false;
    }
    constructor(private forgotPasswordService: ForgotPasswordService, private toastr: ToastrService, private router: Router) { }

    getOTP(reset) {
        if (this.reset.mobileNumber != null && this.reset.mobileNumber != undefined && this.reset.mobileNumber != "") {
            this.forgotPasswordService.getOTP(reset).subscribe(data => {
                this.otpResult = JSON.parse(JSON.stringify(data));
                if (this.otpResult != undefined && this.otpResult.Status != false) {
                    this.toastr.success(this.otpResult.SuccessMessage, 'OTP');
                    this.errorMessageMobileNumber = "";
                    this.hideMobileNumber = false;
                    this.errorMessageNumericMobileNumber = "";
                    //this.reset.mobileNumber='';
                }
                else {
                    this.toastr.error(this.otpResult.ErrorMessage, 'OTP');
                    this.errorMessageMobileNumber = "";
                    this.errorMessageNumericMobileNumber = "";
                    this.reset.mobileNumber='';
                }
            },
                error => {
                    this.toastr.error("Server Error");
                    this.errorMessageMobileNumber = "";
                    this.errorMessageNumericMobileNumber = "";
                });
        }
        else if (this.reset.mobileNumber == null || this.reset.mobileNumber == undefined || this.reset.mobileNumber == "") {
            this.errorMessageMobileNumber = "Please enter valid mobile no";
            this.errorMessageNumericMobileNumber = "";
        }
    }

    keyPressMobileNumber(event: any) {
        const pattern = /^\S/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8 && event.keyCode != 13) {
            this.errorMessageNumericMobileNumber = "Enter only numbers";
            this.errorMessageMobileNumber = "";
            event.preventDefault();
        }
        else {
            this.errorMessageNumericMobileNumber = "";
            this.errorMessageMobileNumber = "";
        }
    }

    keyPressOTPNumber(event: any) {
        const pattern = /[0-9\ ]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (!pattern.test(inputChar) && event.keyCode != 8) {
            this.errorMessageNumericOTP = "Only numbers are allowed";
            this.errorMessageOTP = "";
            event.preventDefault();
        }
        else {
            this.errorMessageNumericOTP = "";
            this.errorMessageOTP = "";
        }
    }
    resetPassword(number: string, otp: string) {
        if (this.reset.otp != null && this.reset.otp != undefined && this.reset.otp != "") {
            this.forgotPasswordService.resetPassword(number, otp).subscribe(
                response => {
                    this.otpResult = JSON.parse(JSON.stringify(response));
                    if (this.otpResult != undefined && this.otpResult.Status != false) {
                        this.toastr.success(this.otpResult.SuccessMessage, 'Reset Password');
                        this.errorMessageNumericOTP = "";
                        this.errorMessageOTP = "";
                        localStorage.setItem('resetMobile', this.reset.mobileNumber);
                        this.router.navigate(['/resetpassword']);
                    }
                    else if (this.otpResult.Status != true) {
                        this.toastr.error(this.otpResult.ErrorMessage, 'Reset Password');
                        this.hideMobileNumber = false;
                        this.errorMessageNumericOTP = "";
                        this.errorMessageOTP = "";
                        this.reset.otp='';
                    }
                },
                error => {
                    this.toastr.error("Server Error");
                    this.errorMessageNumericOTP = "";
                    this.errorMessageOTP = "";
                });
        }
        else if (this.reset.otp == null || this.reset.otp == undefined || this.reset.otp == "") {
            this.errorMessageOTP = "Please enter valid OTP";
            this.errorMessageNumericOTP = "";
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/customer-login/forgot-password/forgetpassword.component.ts